<template>
    <div>
        
        <Content :style="{padding: '24px', minHeight: '480px', background: '#fff'}">
            <el-form ref="waybillExpress" label-position="right" label-width="180px" :model="waybillExpress">
                <el-form-item label="快递选择" prop="expressName">
                    <el-input size="small" v-model="waybillExpress.expressName" placeholder="快递选择" style="width: 240px" />
                </el-form-item>
                <el-form-item label="快递单号" prop="expressNo">
                    <el-input size="small" v-model="waybillExpress.expressNo" placeholder="快递单号" style="width: 240px" />
                </el-form-item>
                <el-form-item label="外部订单号（淘宝阿里）" prop="outOrderNo">
                    <el-input size="small" v-model="waybillExpress.outOrderNo" placeholder="外部订单号（淘宝阿里）" style="width: 240px" />
                </el-form-item>
                <el-form-item label="商品图片" prop="pics">
                    <el-input size="small" v-model="waybillExpress.pics" type="hidden" />
                    <div class="demo-upload-list" v-for="item in uploadList">
                        <template v-if="item.status === 'finished'">
                            <img :src="item.url">
                            <div class="demo-upload-list-cover">
                                <i class="ios-eye-outline" @click.native="handleView(item.url)"></i>
                            </div>
                        </template>
                        <template v-else>
                            <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
                        </template>
                    </div>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input size="small" v-model="waybillExpress.remark" type="textarea" placeholder="备注" style="width: 240px" />
                </el-form-item>
            </el-form>
        </Content>
        <Modal title="大图" v-model="visible">
            <img :src="imgName" v-if="visible" style="width: 100%">
        </Modal>
    </div>
</template>
<script>
import api from "@/api/api"
import Constants from "@/utils/constants"
export default {
    name: 'WaybillExpressEdit',
    data() {
        return {

            loading: false,
            imgName: '',
            visible: false,
            uploadList: [],
            waybillExpress: {},
            expressNo: {

            },
            expresss: []

        };
    },
    mounted: function() {

        this.expressNo = this.$route.params.expressNo;
        this.getDetail();


    },
    computed: {
        // pics: function() {

        //     var p = "";
        //     for (var i = 0; i < this.uploadList.length; i++) {
        //         if (this.uploadList[i].url)
        //             p += "##" + this.uploadList[i].url;
        //     }

        //     return p;
        // }
    },
    methods: {
        getPics: function() {

            var p = "";
            for (var i = 0; i < this.uploadList.length; i++) {
                if (this.uploadList[i].url)
                    p += "##" + this.uploadList[i].url;
            }

            return p;
        },
        getExprList: function() {
            var me = this;
            if (me.expresss.length <= 0) {
                me.$http.post("/express/getall.do", {}).then(response => {
                    var body = response;
                    if (body.status == 0) {

                        me.expresss = body.obj;

                    }

                }, response => {

                });
            }
        },
        getDetail: function() {

            var me = this;

            me.showLoading();
            me.$http.post("/ware/waybillexpress/show.action",{expressNo:me.expressNo}).then(response => {
                var body = response;
                if (body.status == 0) {
                    me.waybillExpress = body.obj;
                    if (me.waybillExpress.pics) {
                        var ps = me.waybillExpress.pics.split("##");

                        for (var i = 0; i < ps.length; i++) {

                            if (ps[i] != '') {
                                // me.defaultList.push({ url: ps[i], name: '', status: 'finished' });
                                me.uploadList.push({ url: ps[i], name: '', status: 'finished' });
                            }
                        }
                    }
                }
                me.hideLoading();
            }, response => {
                me.hideLoading();
            });
        },
        handleView(name) {
            this.imgName = name;
            this.visible = true;
        }

    }
}
</script>
<style scoped>
</style>